import Schema from 'AppReact/schema';
import { required, optional } from 'AppReact/schema';

const tab = {
  display: required('string'),
  id: required('string'),
  icon: optional('string'),
};

export default {
  selectedTabId: Schema('string', 'primitive-nullable', { defaultValue: null }),
  tabs: Schema(tab, 'array', { defaultValue: [] }),
}